import { Theme } from '@mui/material/styles';

export default function Button(theme: Theme) {
  return {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            backgroundColor: theme.palette.grey[200],
          },
        },
      },
    },
  };
}
